import React from 'react';
import { Text } from 'react-native';

export default class CustomText extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Text
        {...this.props}
        style={[
          {
            fontFamily: 'Mulish,Helvetica Neue,Helvetica,Arial,sans-serif',
          },
          this.props.style,
        ]}
      />
    );
  }
}
